import { createSaga } from './saga-helpers';

import * as Api from '../api/labels-api';

const watchGetLabels = createSaga({
    type: 'LABELS_FETCH',
    fn: Api.fetchLabels,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        labels: items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateLabel = createSaga({
    type: 'LABEL_CREATE',
    fn: Api.createLabel,
    args: action => [action.payload.label],
    successPayload: ({ id: labelId }, action) => ({
        labelId,
        fragment: action.payload.label
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.label
    })
});

const watchGetLabel = createSaga({
    type: 'LABEL_FETCH',
    fn: Api.fetchLabel,
    args: action => [action.payload.labelId],
    successPayload: label => ({ label })
});

const watchUpdateLabel = createSaga({
    type: 'LABEL_UPDATE',
    fn: Api.updateLabel,
    args: action => [action.payload.labelId, action.payload.labelProps],
    successPayload: label => ({ label })
});

const watchRemoveLabel = createSaga({
    type: 'LABEL_REMOVE',
    fn: Api.removeLabel,
    args: action => [action.payload.labelId]
});

const sagas = [watchGetLabels, watchCreateLabel, watchGetLabel, watchUpdateLabel, watchRemoveLabel];

export default sagas;
